import { WELCOME_SLIDE } from "../apiConstant";
import BaseApi from "../baseApi";

class WelcomeSlide extends BaseApi {
  saveSlides(payload) {
    return this.post(`${WELCOME_SLIDE}/slides`, payload);
  }

  getSlides(params) {
    return this.get(`${WELCOME_SLIDE}/slides?${params}`);
  }

  deleteSlide(slideId) {
    return this.delete(`${WELCOME_SLIDE}/slides/${slideId}`);
  }

  createTemplate(payload) {
    return this.post(`${WELCOME_SLIDE}/template`, payload);
  }

  getTemplate() {
    return this.get(`${WELCOME_SLIDE}/template`);
  }
}
export default WelcomeSlide;
